// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33rCt","colBig":"styles_colBig__1ClM7","colSmall":"styles_colSmall__sGdTD"};